import { TObjectShareResponse } from "../../../../../services/api/instances/storageApi/types/service_types";
import { AppAutocomplete } from "../../../../../shared/components/AppAutocomplete";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { AppLabel } from "../../../../../shared/components/AppLabel";
import { TrashIcon } from "../../../../../shared/icons/TrashIcon";
import { TPermissionAction } from "../types";
import { useUsersAutocomplete } from "./hook/use-users-autocomplete";
import styles from "./styles.module.css";

interface Props {
  permission: TObjectShareResponse;
  handleChangeFields: (
    data: string | string[] | Date | null,
    type: TPermissionAction,
    id: string,
  ) => void;
  handleRevokeAccess: (id: number) => void;
  handleDeleteBlock: (id: number) => void;
  hasDeleteBlockButton?: boolean;
}

export const UsersAutocomplete = ({
  permission,
  handleChangeFields,
  handleRevokeAccess,
  handleDeleteBlock,
  hasDeleteBlockButton,
}: Props) => {
  const { value, handleChange, renderTags, renderInput } = useUsersAutocomplete(
    permission,
    handleChangeFields,
    handleRevokeAccess,
    handleDeleteBlock,
    {
      classNames: {
        chip: styles["custom-chip"],
        input: styles["custom-input"],
        adornment: styles["custom-adornment"],
      },
    },
  );
  return (
    <div className={styles["username-container"]}>
      <div className={styles["label-container"]}>
        <AppLabel>Имена пользователей</AppLabel>
        <div className={styles["permission-block-actions"]}>
          {hasDeleteBlockButton && (
            <AppIconButton
              onClick={() => handleDeleteBlock(permission.id)}
              className={styles["action-btn"]}
            >
              <TrashIcon />
            </AppIconButton>
          )}
        </div>
      </div>
      <AppAutocomplete
        freeSolo
        multiple
        noOptionsText="Нажмите Enter чтобы добавить пользователя"
        value={value}
        options={[]}
        onChange={handleChange}
        renderTags={renderTags}
        renderInput={renderInput}
        classes={{
          inputRoot: styles["autocomplete-container"],
          input: styles["autocomplete-input"],
        }}
      />
    </div>
  );
};
